import axios from "axios";
import { ResponseRequestGeneric } from "components/Types/GeneralTypes";
import { authHeader } from "helpers/auth-header";
import config from "config.json"
import { hadleAxiosErrorResponse, handleAxiosErrorResponseBlob } from "helpers/handle-response";
import { authenticationService } from "services/authentication.service";
import { HojaMarcacionesNovedad, RequestGuardarHojaMarcacion } from "./TypeHojaMarcaciones";


const URL_MARCACIONES_CONTROLLER = `${config.SERVER_URL}HojaMarcaciones`;



const URL_CONSULTA_HOJA_MARCACIONES = `${URL_MARCACIONES_CONTROLLER}`;
const URL_CONSULTA_HOJA_MARCACIONES_NOVEDAD = `${URL_MARCACIONES_CONTROLLER}/HojaMarcacionesNovedad`;
const URL_GUARDAR_MARCACIONES = `${URL_MARCACIONES_CONTROLLER}`;





export async function GetHojaMarcacion(fechaDesde: Date, fechaHasta: Date,identificacion:string = "") {
    var respuesta: ResponseRequestGeneric<string> = {
        status: -1
    }

    const fechaDesdeParse = `${fechaDesde.getFullYear()}-${fechaDesde.getMonth() + 1}-${fechaDesde.getDate()}`
    const fechaHastaParse = `${fechaHasta.getFullYear()}-${fechaHasta.getMonth() + 1}-${fechaHasta.getDate()}`

    var paramidentificacion = authenticationService.currentUserValue.identificacion;

    if(identificacion !== ""){
        paramidentificacion = identificacion;
    }

    try {
        const response = await axios.get(URL_CONSULTA_HOJA_MARCACIONES, {
            headers: authHeader(),
            responseType: "blob",
            params: {
                identificacion:paramidentificacion,
                fechainicio: fechaDesdeParse,
                fechafin: fechaHastaParse
            }
        })

        const blob_resource = await response.data;
        const url_documento = window.URL.createObjectURL(blob_resource);

        respuesta.status = response.status
        respuesta.dataResponse = url_documento;


    } catch (error) {
        respuesta = await handleAxiosErrorResponseBlob(error);
    }

    return respuesta;
}

export async function GetHojaMarcacionNovedad(fechaDesde: Date, fechaHasta: Date) {
    var respuesta: ResponseRequestGeneric<HojaMarcacionesNovedad> = {
        status: -1
    }

    const fechaDesdeParse = `${fechaDesde.getFullYear()}-${fechaDesde.getMonth() + 1}-${fechaDesde.getDate()}`
    const fechaHastaParse = `${fechaHasta.getFullYear()}-${fechaHasta.getMonth() + 1}-${fechaHasta.getDate()}`


    try {
        const response = await axios.get(URL_CONSULTA_HOJA_MARCACIONES_NOVEDAD, {
            headers: authHeader(),
            params: {
                identificacion: authenticationService.currentUserValue.identificacion,
                fechainicio: fechaDesdeParse,
                fechafin: fechaHastaParse
            }
        })

        const respuestaData: HojaMarcacionesNovedad = response.data;

        // Convertir la cadena base64 a un arreglo de bytes
        const byteCharacters = atob(respuestaData.hojamarcacion);  // Decodifica base64 a bytes
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        // Crear un Uint8Array a partir de byteNumbers
        const byteArray = new Uint8Array(byteNumbers);

        // Crear un Blob con los datos PDF
        const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });

        if (pdfBlob) {
            // Generar la URL del objeto para descargar el PDF
            const url = window.URL.createObjectURL(pdfBlob);
            
            // En lugar de mostrar directamente en un modal, almacenar en el objeto de respuesta
            respuesta.status = response.status;
            respuesta.dataResponse = {
                hojamarcacion: url,
                tienenovedad: respuestaData.tienenovedad,
                referenciaHojaGuardada:respuestaData.referenciaHojaGuardada
            };

        }

    } catch (error) {
        respuesta = hadleAxiosErrorResponse(error);
    }

    return respuesta;
}

export async function GuardarHojaMarcaciones(fechaDesde: Date, fechaHasta: Date) {
    var respuesta: ResponseRequestGeneric<void> = {
        status: -1
    }

    const fechaDesdeParse = `${fechaDesde.getFullYear()}-${fechaDesde.getMonth() + 1}-${fechaDesde.getDate()}`
    const fechaHastaParse = `${fechaHasta.getFullYear()}-${fechaHasta.getMonth() + 1}-${fechaHasta.getDate()}`

    const objetoEnviar:RequestGuardarHojaMarcacion = {
        fechaInicio:fechaDesdeParse,
        fechaFin:fechaHastaParse
    }

    try {
        const response = await axios.post(URL_GUARDAR_MARCACIONES,objetoEnviar, {
            headers: authHeader()
        })

        
        respuesta.status = response.status
        


    } catch (error) {
        respuesta = hadleAxiosErrorResponse(error);
    }

    return respuesta;
}


